import { __extends } from "tslib";
import { Entity } from "./Entity";
/**
 * Presets for common UI elements.
 */
var InterfaceColors = /** @class */ (function (_super) {
    __extends(InterfaceColors, _super);
    function InterfaceColors() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(InterfaceColors, "className", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "InterfaceColors"
    });
    Object.defineProperty(InterfaceColors, "classNames", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: Entity.classNames.concat([InterfaceColors.className])
    });
    return InterfaceColors;
}(Entity));
export { InterfaceColors };
//# sourceMappingURL=InterfaceColors.js.map